import sharedUtils from "../grid/sharedUtilities";

type NullableDate = Date | null | undefined;
export interface promotionTemplatesFormRequest {
    id: string;
    businessEntityId: string;
    serviceTypeId: string;
    serviceSubTypeId: string;
    typeLookUpId: string;
    link: string;
    linkTypeId: string;
    active: boolean;
    description: string;
}

export interface promotionTemplatesFormResponse {
    id: string;
    businessEntityId: string;
    businessEntity: string;
    serviceTypeId: string;
    serviceType: string;
    serviceSubTypeId: string;
    serviceSubType: string;
    typeLookUpId: string;
    typeLookUp: string;
    linkTypeId: string;
    linkType: string;
    active: string;
    description: string;
    link: string;
    lastUpdatedOn: string;
    lastUpdatedBy: string;
    brandId:string;
    promotionTemplateTextStylesId:string
}
export interface AddEditPromotionTemplatesFormData {
    id: string;
    businessEntityId: string;
    businessEntity: string;
    serviceTypeId: string;
    serviceType: string;
    serviceSubTypeId: string;
    serviceSubType: string;
    typeLookUpId: string;
    typeLookUp: string;
    linkTypeId: string;
    linkType: string;
    active: boolean;
    description: string;
    link: string;
    lastUpdatedOn: string;
    lastUpdatedBy: string;
    brandId:string;
    promotionTemplateTextStylesId:string
}

export default class promotionTemplatesFormUtil {
    utils: sharedUtils;
    constructor() {
        this.utils = new sharedUtils();
        this.initializePromotionTemplateFormItem = this.initializePromotionTemplateFormItem.bind(this);
        this.convertPromotionTemplateItemResponeToFormData = this.convertPromotionTemplateItemResponeToFormData.bind(
            this
        );
    }

    initializePromotionTemplateFormItem(): AddEditPromotionTemplatesFormData {
        var formData: AddEditPromotionTemplatesFormData = {
            id: "",
            businessEntityId: "",
            businessEntity: "",
            serviceTypeId: "",
            serviceType: "",
            serviceSubTypeId: "",
            serviceSubType: "",
            typeLookUpId: "",
            typeLookUp: "",
            link: "",
            linkTypeId: "",
            linkType: "",
            active: true,
            description: "",
            lastUpdatedOn: "",
            lastUpdatedBy: "",
            brandId:"",
            promotionTemplateTextStylesId:""
        };

        return formData;
    }

    // Convert the server response into the component's form state
    convertPromotionTemplateItemResponeToFormData(
        serverResponse: promotionTemplatesFormResponse
    ): AddEditPromotionTemplatesFormData {
        var formData: AddEditPromotionTemplatesFormData = {
            id: serverResponse.id,
            businessEntityId: serverResponse.businessEntityId,
            serviceTypeId: serverResponse.serviceTypeId,
            serviceSubTypeId: serverResponse.serviceSubTypeId,
            typeLookUpId: serverResponse.typeLookUpId,
            businessEntity: serverResponse.businessEntity,
            serviceType: serverResponse.serviceType,
            serviceSubType: serverResponse.serviceSubType,
            typeLookUp: serverResponse.typeLookUp,
            link: serverResponse.link,
            linkTypeId: serverResponse.linkTypeId,
            linkType: serverResponse.linkType,
            active: serverResponse.active==="True"?true:false,
            description: serverResponse.description,
            lastUpdatedOn: serverResponse.lastUpdatedOn,
            lastUpdatedBy: serverResponse.lastUpdatedBy,
            brandId:serverResponse.brandId,
            promotionTemplateTextStylesId:serverResponse.promotionTemplateTextStylesId
        };

        return formData;
    }

    // Convert the form's data into a proper item submit request
    convertFormDataToPromotionTemplateItemRequest(
        formData: AddEditPromotionTemplatesFormData
    ): promotionTemplatesFormRequest {
        var submitRequest: promotionTemplatesFormRequest = {
            id: formData.id,
            businessEntityId: formData.businessEntityId,
            serviceTypeId: formData.serviceTypeId,
            serviceSubTypeId: formData.serviceSubTypeId,
            typeLookUpId: formData.typeLookUpId,
            link: formData.link,
            linkTypeId: formData.linkTypeId,
            active: formData.active,
            description: formData.description,
        };

        return submitRequest;
    }

    //A helper function that would check the Validation for "Name in case of Rate Matrix Grid.
    nameValidation = (typeId: string, typeValue: string, name: string): boolean => {
        var validationSuccess: boolean = true;
        var nameField = name ? name.trim() : "";
        if (typeId && typeValue) {
            if (!nameField || (nameField && nameField.split(" ").length != 2)) {
                validationSuccess = false;
            }
        }
        return validationSuccess;
    };

    shortNameValidation = (typeId: string, typeValue: string, name: string): boolean => {
        var isValid: boolean = false;
        var nameField = name ? name.trim() : "";
        if (typeId && typeValue) {
            if (nameField) {
                isValid = true;
            }
        }
        return isValid;
    };
}
